/**
 * L'ASCENSEUR DE L'HOTEL: un panneau de BOUTONS, un par niveau.
 *
 * L'escalier de la villa bascule entre deux niveaux d'un seul tap — il n'y a
 * rien a choisir. Trois destinations, elles, ne se devinent pas: l'ascenseur
 * ouvre donc ses boutons, comme une vraie cabine. Un pave de boutons, aucun
 * champ de saisie — la regle du panneau de l'ecole, et celle de tout le jeu.
 *
 * Le panneau ne DEPLACE personne: il rend le niveau choisi a `onChoix`, et
 * c'est le jeu qui passe par `changerNiveau`, ou le niveau n'est que PROPOSE —
 * `appliquerEntree` tranche au tick suivant, des deux cotes du fil.
 */
import { journal } from '../log/journal.ts'
import { Panneau, bouton, el } from './commun.ts'

export class PanneauAscenseur extends Panneau {
  private onChoix: ((niveau: number) => void) | null = null

  constructor(parent: HTMLElement) {
    super(parent, 'ascenseur', 'Ascenseur', '🛗')
  }

  /**
   * `niveauActuel` marque l'etage ou l'on est (son bouton ne fait rien de
   * plus que fermer), `niveauMax` vient de `niveauxDe(kind)` et `noms` du
   * plan du modele (`nomsNiveaux`): le panneau ne connait pas l'hotel, il ne
   * connait que des etages.
   */
  ouvrir(
    niveauActuel: number,
    niveauMax: number,
    noms: readonly string[],
    onChoix: (niveau: number) => void,
  ): void {
    this.onChoix = onChoix
    this.viderCorps()
    this.viderPied()
    this.corps.append(el('p', 'musee__attente', 'Choisis ton étage.'))
    const liste = el('div', 'ascenseur__boutons')
    // Du haut vers le bas, comme les boutons d'une vraie cabine.
    for (let n = niveauMax; n >= 0; n--) {
      const nom = noms[n] ?? `Étage ${n}`
      const b = bouton(n === niveauActuel ? `● ${nom} (tu es ici)` : nom, () => this.choisir(n))
      b.classList.add('ascenseur__bouton')
      if (n === niveauActuel) b.disabled = true
      liste.append(b)
    }
    this.corps.append(liste)
    this.afficher(`niveau ${niveauActuel}`)
  }

  private choisir(niveau: number): void {
    journal.input('ascenseur', `bouton niveau ${niveau}`)
    const rappel = this.onChoix
    this.onChoix = null
    this.fermer()
    rappel?.(niveau)
  }
}
